<form [formGroup]="formGroup">
  <div class="bg-white p-3" style="border-radius: 4px">
    <div class="w-100 d-flex justify-content-between">
      <h4>{{ 'exchange.card-info' | translate }}</h4>
      <div>
        <lucide-icon [name]="expand ? 'chevron-up' : 'chevron-down'" (click)="expand = !expand"></lucide-icon>
      </div>
    </div>
    <div *ngIf="expand" nz-row [nzGutter]="[16, 16]">
      <div nz-col nzSpan="24">
        <app-control formControlName="card_no" [controlConfig]="{title: 'card.code', type: 'text', required: true}"></app-control>
      </div>
      <div nz-col nzSpan="12">
        <app-control formControlName="owner" [controlConfig]="{title: 'service-card.owner', type: 'text', required: true}"></app-control>
      </div>
      <div nz-col nzSpan="12">
        <app-control formControlName="apartment_ids" [options]="listApartmentByCard" [controlConfig]="{title: 'apartment.code', type: 'dropdown-multi', required: true}"></app-control>
      </div>
      <div nz-col nzSpan="12">
        <app-control formControlName="reason" [controlConfig]="{title: 'reason', type: 'textarea'}"></app-control>
      </div>
      <div nz-col nzSpan="12">
        <app-control formControlName="note" [controlConfig]="{title: 'note', type: 'textarea'}"></app-control>
      </div>
    </div>
    <label *ngIf="!apartment" style="color: #8e8e8e">{{'service-card.operation-warning' | translate}}</label>
    <label *ngIf="apartment" style="color: #8e8e8e">{{'service-card.operation-warning-apartment' | translate: {apartment: apartment.code} }}</label>
  </div>
  <div class="bg-white p-3 mt-3" style="border-radius: 4px">
    <div class="w-100 d-flex justify-content-between">
      <h4 class="mb-0">{{ 'exchange.service-info' | translate }}</h4>
      <div>
        <lucide-icon [name]="expandService ? 'chevron-up' : 'chevron-down'" (click)="expandService = !expandService"></lucide-icon>
      </div>
    </div>
    <div *ngIf="expandService" class="mt-3">
      <nz-table #table [nzData]="listDetailService" nzTableLayout="auto" [nzBordered]="true" nzSize="small" [nzShowPagination]="false">
        <thead>
          <tr>
            <th class="text-center" style="width: 60px">{{ 'index' | translate }}</th>
            <th style="width: 200px">{{ 'print.table.service' | translate }}</th>
            <th>{{ 'report-excel.apartment_type' | translate }}</th>
            <th>{{ 'top-up.guest-type' | translate }}</th>
            <th>{{ 'exchange.converted-quantity' | translate }}</th>
            <th>{{ 'exchange.remaining-quantity' | translate }}</th>
            <th>{{ 'payment.date-expire' | translate }}</th>
            <th>{{ 'exchange.adjustment-quantity' | translate }}</th>
            <th>{{ 'exchange.expire-date' | translate }}</th>
            <th>{{ 'exchange.difference' | translate }}</th>
            <th>{{ 'exchange.action' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listDetailService; let i = index">
            <td class="text-center">{{ i + 1 }}</td>
            <td>
                <app-model *ngIf="item.isNewRow" [options]="listPackage" [value]="item['package_id']" (modelValueChange)="onChangeService(item, $event)"
                  [controlConfig]="{type: 'dropdown', label: '', required: true}"></app-model>
                <span *ngIf="!item.isNewRow">{{item.package_name}}</span>
            </td>
            <td>
                <app-model *ngIf="item.isNewRow" [options]="listApartmentType" [value]="item['apartment_type_id']" (modelValueChange)="onChangeApartmentType(item, $event)"
                  [controlConfig]="{type: 'dropdown', label: '', required: true}"></app-model>
                <span *ngIf="!item.isNewRow">{{item.apartment_type_name}}</span>
            </td>
            <td>
                <app-model *ngIf="item.isNewRow" [options]="listGuestType" [value]="item['guest_type']" (modelValueChange)="onChangeGuestType(item, $event)"
                  [controlConfig]="{type: 'dropdown', label: '', required: true}"></app-model>
                <ng-container *ngIf="!item.isNewRow">
                  <ng-container *ngFor="let type of listGuestType">
                    <span *ngIf="type.value === item['guest_type']">{{ type.text | translate }}</span>
                  </ng-container>
                </ng-container>
            </td>
            <td>{{item.total_amount ? (item.total_amount | number) : '-'}}</td>
            <td>{{item.remaining_stock ? (item.remaining_stock | number) : '-'}}</td>
            <td>{{item.expired_date ? (item.expired_date | date: 'dd/MM/yyyy') : '-'}}</td>
            <td>
              <app-model style="width: 80px;" [value]="item['exchange_amount']" (modelValueChange)="onChangeQuantity(item, $event)"
                [controlConfig]="{type: 'number', label: 'exchange.adjustment-quantity'}"></app-model>
            </td>
            <td>
              <app-model [value]="item['exchange_expired_date']" (modelValueChange)="onChangeDateService(item, $event)" [min]="currentDate"
                [controlConfig]="{type: 'date', label: 'exchange.expire-date'}"></app-model>
            </td>
            <td><span [ngClass]="item.difference < 0 ? 'text-danger' : 'text-success'">{{item.difference | number}}</span></td>
            <td class="text-center">
              <app-button *ngIf="item.isNewRow" [type]="'icon'" [label]="'trash-2'" (clickButton)="deleteService(i)"></app-button>
            </td>
          </tr>
          <tr>
            <td class="text-center">{{ 'print.total' | translate }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{total_exchange | number}}</td>
            <td>{{remaining_stock | number}}</td>
            <td></td>
            <td>{{total_service | number}}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </nz-table>
    </div>
    <div class="mt-3">
      <div class="fs-14 mb-2">
        <app-button [iconLeft]="'plus'" [type]="'primary'" [label]="'addChild' | translate" (click)="addService()"></app-button>
      </div>
    </div>
  </div>
  <div class="bg-white p-3 mt-3" style="border-radius: 4px">
    <div class="w-100 d-flex justify-content-between">
      <h4>{{ 'exchange.cash-info' | translate }}</h4>
      <lucide-icon [name]="expandExchange? 'chevron-up' : 'chevron-down'" (click)="expandExchange = !expandExchange" class="ms-2"></lucide-icon>
    </div>
    <div *ngIf="expandExchange">
      <nz-table #table [nzData]="listDetailCash" nzTableLayout="auto" [nzBordered]="true" nzSize="small" [nzShowPagination]="false">
        <thead>
          <tr>
            <th class="text-center">{{ 'index' | translate }}</th>
            <th>{{ 'exchange.converted-amount' | translate }}</th>
            <th>{{ 'exchange.remaining-amount' | translate }}</th>
            <th>{{ 'payment.date-expire' | translate }}</th>
            <th>{{ 'exchange.adjustment-amount' | translate }}</th>
            <th>{{ 'exchange.expire-date' | translate }}</th>
            <th>{{ 'exchange.difference' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listDetailCash; let i = index">
            <td class="text-center" style="background-color: #F9FAFB">{{ i + 1 }}</td>
            <td>{{item.total_amount ? (item.total_amount | number) : '-'}}</td>
            <td>{{item.total_amount_remaining ? (item.total_amount_remaining | number) : '-'}}</td>
            <td>{{item.expired_date ? (item.expired_date | date: 'dd/MM/yyyy') : '-'}}</td>
            <td>
              <app-model [value]="item['exchange_amount']" (modelValueChange)="onChangeAmount(item, $event)"
                [controlConfig]="{type: 'number', label: 'exchange.adjustment-amount'}"></app-model>
            </td>
            <td>
              <app-model [value]="item['exchange_expired_date']" (modelValueChange)="onChangeDateCash(item, $event)" [min]="currentDate"
                [controlConfig]="{type: 'date', label: 'exchange.expire-date'}"></app-model>
            </td>
            <td><span [ngClass]="item.difference < 0 ? 'text-danger' : 'text-success'">{{item.difference | number}}</span></td>
          </tr>
          <tr>
            <td class="text-center">{{ 'print.total' | translate }}</td>
            <td>{{total_amount | number}}</td>
            <td>{{total_amount_remaining | number}}</td>
            <td></td>
            <td>{{total_cash | number}}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</form>

<div *nzModalTitle class="title-modal">
  <span>{{'exchange.label' | translate}}</span>
</div>
<div *nzModalFooter>
  <button nz-button class="btn-cancel-modal" (click)="destroyModal()">{{ 'close' | translate }}</button>
  <button nz-button nzType="primary" (click)="onSave()">{{ 'save' | translate }}</button>
</div>